import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import "./Footer.css";
import WebLogicLogo from "../../Imge/ti.png";
import axios from "axios";
import { baseURL } from "../../API/API";

export default function Footer() {
  const [supportPhone, setSupportPhone] = useState("01031360031");

  useEffect(() => {
    axios.get(`${baseURL}/learning/settings`)
      .then(res => {
        if (res.data?.data?.support_phone) {
          setSupportPhone(res.data.data.support_phone);
        }
      })
      .catch(err => console.log(err));
  }, []);

  return (
    <footer className="footer-section" dir="rtl">
      <Container>
        <Row className="g-4 align-items-start justify-content-between text-end py-5">
          {/* Column 1 (Left in RTL / Right visually): Support & Help Button */}
          <Col lg={3} md={6} className="d-flex flex-column align-items-center align-items-md-start mb-4">
            <h5 className="footer-title-red mb-3">تواصل مع دعم مستر محمود الصبروط من هنا</h5>
            <span className="pointing-hand-emoji mb-3">👇🏻</span>
            <a 
              href={`https://wa.me/2${supportPhone.replace(/^0/, "")}`}
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-help-support"
            >
              المساعدة
            </a>
          </Col>

          {/* Column 2: Social Media */}
          <Col lg={3} md={6} className="mb-4">
            <h5 className="footer-title-red mb-3">السوشيال ميديا</h5>
            <ul className="footer-links-list list-unstyled p-0 m-0">
              <li className="mb-2">
                <a 
                  href="https://www.facebook.com/elsabroutm3?rdid=6Ox4OtIUYTB3WpEe&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1AtvUxo7Ke%2F#" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-social-link"
                >
                  <FaFacebook className="facebook-icon-footer me-2" /> فيسبوك
                </a>
              </li>
              <li className="mb-2">
                <a 
                  href="https://www.instagram.com/nouhacadeemy?igsh=cnlhOW50MXdnNDQz" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-social-link"
                >
                  <FaInstagram className="instagram-icon-footer me-2" /> انستجرام
                </a>
              </li>
              <li className="mb-2">
                <a 
                  href="https://www.youtube.com/@nouhacadeemy" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-social-link"
                >
                  <FaYoutube className="youtube-icon-footer me-2" /> يوتيوب
                </a>
              </li>
            </ul>
          </Col>

          {/* Column 3: Navigation Pages */}
          <Col lg={2} md={6} className="mb-4">
            <h5 className="footer-title-red mb-3">الصفحات</h5>
            <ul className="footer-links-list list-unstyled p-0 m-0">
              <li className="mb-2">
                <NavLink to="/" end className="footer-page-link">
                  الرئيسية
                </NavLink>
              </li>
              <li className="mb-2">
                <NavLink to="/register" className="footer-page-link">
                  انشاء حساب جديد
                </NavLink>
              </li>
              <li className="mb-2">
                <NavLink to="/login" className="footer-page-link">
                  تسجيل الدخول
                </NavLink>
              </li>
            </ul>
          </Col>

          {/* Column 4 (Right in RTL / Left visually): Logo & Rights */}
          <Col lg={3} md={6} className="d-flex flex-column align-items-center align-items-md-end mb-4">
            <div className="footer-logo-title mb-2">نوح أكاديمي</div>
            <div className="footer-copyright-text mb-2">جميع الحقوق محفوظة © 2026</div>
            <a 
              href="https://wa.me/201066726354" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="d-flex align-items-center gap-2 mt-2 text-decoration-none"
              style={{ direction: "rtl", cursor: "pointer" }}
            >
              <img 
                src={WebLogicLogo} 
                alt="Web Logic Logo" 
                style={{ 
                  width: "28px", 
                  height: "28px", 
                  borderRadius: "50%", 
                  objectFit: "cover",
                  border: "1px solid rgba(255,255,255,0.2)"
                }} 
              />
              <span style={{ fontSize: "0.85rem", color: "var(--text-secondary)", fontWeight: 600 }}>
                تصميم وبرمجة شركة Web Logic
              </span>
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
